// extracted by mini-css-extract-plugin
export default {"subMenu":"subMenu--asJfV","slideIn":"slideIn--yZZ3C","slideOut":"slideOut--PIgOP","brandColorOnHover":"brandColorOnHover--toFDA"};